<div [@routerTransition]>
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="card my-profile-form margin-top-15px top-link" *ngIf="ShowList">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="row">
        <div class="col-md-3">
          Admissions
        </div>
        <div class="col-md-8 padding-right-0px">
          <div class="row">
            <div class="offset-md-3 col-md-2 padding-right-0px text-align-center">
              <a (click)="OpenBill()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Admission" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
            </div>
            <div class="col-md-3 col-sm-3 padding-right padding-left-0px">
              <div class="form-group  margin-bottom-5px">
                <div class="row">
                  <div class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                    <a (click)="DecrementDate()" title="Previous" class="nav-link-hand">
                      <i class="fas fa-caret-left margin-top-3px font-size-24px"></i>
                    </a>
                  </div>
                  <div class="col-md-8 col-sm-4 padding-l-0px padding-right-9px">
                    <div class="date-form">
                      <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-24px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                             (ngModelChange)="dataChanged($event)">
                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                      </a>
                    </div>
                  </div>
                  <div class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                    <a (click)="IncrementDate()" title="Next" class="nav-link-hand">
                      <i class="fas fa-caret-right margin-top-3px font-size-24px"></i>
                    </a>
                  </div>

                  <div class="col-md-1 padding-left-0px">
                    <a class="nav-link-hand education-navlink data-color-new" title="print">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
              <form novalidate="" #f="ngForm" class="display-inherit">
                <div class="clear-form">
                  <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
                  <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
                </div>
                <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
              </form>
              <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
              <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>-->
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div class="row">
        <div class="col-md-12">
          <div class="table-component">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr>
                    <th class="min-width-24px">
                      #
                    </th>
                    <th class="">
                      Patient
                    </th>

                    <!--<th class="text-align-center">Day</th>-->
                    <!--<th class="text-align-center">
                      Old Reg No
                    </th>-->
                    <th class="">
                      Admission No
                    </th>
                    <!--<th class="text-align-center">Start Time</th>-->
                    <th class="">
                      Admitted On
                    </th>



                    <th class="">
                      Admission Reason
                    </th>
                    <th class="">
                      Insurance
                    </th>
                    <th class="">Dis.Int</th>
                    <th class="">Room</th>
                    <th class="">Ward</th>
                    <th class="">
                      Location
                    </th>
                    <th class="">Status</th>

                  </tr>
                </thead>

                <tbody class="table-body">
                  <tr *ngFor="let l of CurrentAdmissionsListController;let RowIndex = index">
                    <td class="td-padding-tb">
                      {{RowIndex+1}}
                    </td>
                    <td class="td-padding-tb">
                      {{l.PatientName}}
                    </td>

                    <td class=" td-padding-tb">{{l.AdmissionNo}}</td>

                    <td class=" td-padding-tb">{{l.AdmittedOn | date:'dd-MMM-yyyy'}}</td>


                    <td class="td-padding-tb">{{l.AdmissionReason}}</td>
                    <td class="td-padding-tb ">

                      <div class="text-align-center" *ngIf="l.HasTpi">
                        <label class="margin-bottom-0px font-size-14"><i class="fa fa-check adm-color-green"></i></label>
                      </div>
                      <div class="text-align-center" *ngIf="!l.HasTpi">
                        <label class="margin-bottom-0px font-size-14"><i class="fa fa-times"></i></label>
                      </div>

                    </td>
                    <td class=" td-padding-tb ">

                      <div class="text-align-center" *ngIf="l.IsDischargeInitiated">
                        <label class="margin-bottom-0px font-size-14"><i class="fa fa-check adm-color-green"></i></label>
                      </div>
                      <div class="text-align-center" *ngIf="!l.IsDischargeInitiated">
                        <label class="margin-bottom-0px font-size-14"><i class="fa fa-times"></i></label>
                      </div>

                    </td>
                    <td class=" td-padding-tb ">
                      {{l.Ward}}
                    </td>
                    <td class=" td-padding-tb ">
                      {{l.Room}}
                    </td>
                    <td class="td-padding-tb">
                      {{l.FacilityName}}
                    </td>
                    <td class=" td-padding-tb ">
                      <a data-toggle="tooltip" class="cursor" data-placement="bottom" *ngIf="l.AdmissionStatus=='ADMTD'">
                        <i class="fas fa-circle adm-color-green font-size-14"></i>Admitted
                      </a>
                      <a data-toggle="tooltip" class="cursor" data-placement="bottom" *ngIf="l.AdmissionStatus=='ADMPL'">
                        <i class="fas fa-circle adm-color-blue font-size-14"></i>Planned
                      </a>
                      <a data-toggle="tooltip" class="cursor" data-placement="bottom" *ngIf="l.AdmissionStatus=='ADMWL'">
                        <i class="fas fa-circle adm-color-orange font-size-14"></i>Waiting List
                      </a>
                      <a data-toggle="tooltip" class="cursor" data-placement="bottom" *ngIf="l.AdmissionStatus=='DISCH'">
                        <i class="fas fa-circle adm-color-yellow font-size-14"></i>Discharged
                      </a>
                    </td>
                    <td class=" td-padding-tb ">
                      <a class="nav-link-hand education-navlink" title="To Details" (click)="edit(l)">
                        <span class="badge">
                          <i class="fas fa-external-link-alt"></i>
                        </span>
                      </a>
                      <!--<a class="nav-link-hand education-navlink" title="Edit" (click)="edit()">
                        <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                      </a>-->
                    </td>

                  </tr>

                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

